exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody .el-table th.gutter {\n  display: table-cell !important;\n}\n.el-message--error {\n  z-index: 9999!important;\n}\n", ""]);

// exports
